import { render, staticRenderFns } from "./AdminRegister.vue?vue&type=template&id=60af89e0&scoped=true"
import script from "./AdminRegister.vue?vue&type=script&lang=js"
export * from "./AdminRegister.vue?vue&type=script&lang=js"
import style0 from "./AdminRegister.vue?vue&type=style&index=0&id=60af89e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60af89e0",
  null
  
)

export default component.exports